export const attributeMapping: Record<string, string> = {
  'attributes.brand': 'brand',
  'variants.attributes.colour': 'colour',
  'variants.attributes.size': 'size',
  'categoryKeys.en-GB': 'category',
  gender: 'gender',
  'offer.id': 'offer',
  'standalonePrice.priceGB': 'price',
  'standalonePrice.priceEU': 'price',
  customFit: 'fit',
  'categories.en-GB.lvl0': 'department',
  'categories.en-GB.lvl1': 'category',
  'attributes.division': 'division',
  'variants.attributes.waist': 'waist size',
  'variants.attributes.shoesize': 'shoe size',
  'variants.attributes.shafttype': 'shaft',
  'variants.attributes.hand': 'hand',
  _collections: 'collection',
  colour: 'colour',
  'attributes.Feature': 'feature',
  'variants.attributes.loft': 'loft',
};

export const stateMappingtoAttributes: Record<string, string> = {
  brand: 'attributes.brand',
  colour: 'colour',
  size: 'variants.attributes.size',
  weight: 'attributes.weight',
  department: 'categories.en-GB.lvl0',
  category: 'categories.en-GB.lvl1',
  gender: 'gender',
  offer: 'offer.id',
  price: 'standalonePrice.priceGB',
  fit: 'customFit',
  division: 'attributes.division',
  'waist size': 'variants.attributes.waist',
  'shoe size': 'variants.attributes.shoesize',
  shaft: 'variants.attributes.shafttype',
  hand: 'variants.attributes.hand',
  collection: '_collections',
  feature: 'attributes.Feature',
  loft: 'variants.attributes.loft',
};

export const attributeMappingValue: Record<string, string> = {
  'UNDER-ARMOUR': 'UNDERARMOU',
  'DUCA-DEL-COSMA': 'DUCADELCOS',
  TILEIST: 'TITLEIST',
  'SHOT-SCOPE': 'SHOT SCOPE',
  WILSON: 'WILSON ST',
  FAZER: 'FAZER PRO',
  'WILSON-ST': 'WILSON ST',
  RIFE: 'RIFE',
};
export const stateMappingtoAttributesValue: Record<string, string> = {
  underarmou: 'under-armour',
  ducadelcos: 'duca-del-cosma',
};
